import { useState, useCallback, useRef } from "react";
import { fetchTTS } from "../lib/api";

// Tries AI-generated OpenAI TTS first, falls back to browser Web Speech API.
export function useSpeak() {
  const [speaking, setSpeaking] = useState(false);
  const audioRef = useRef(null);

  const browserSpeak = useCallback((text) => {
    try {
      if (!("speechSynthesis" in window)) return;
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.rate = 0.85;
      u.pitch = 1.2;
      u.onend = () => setSpeaking(false);
      u.onerror = () => setSpeaking(false);
      window.speechSynthesis.speak(u);
    } catch (e) {
      setSpeaking(false);
    }
  }, []);

  const speak = useCallback(
    async (text) => {
      setSpeaking(true);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      try {
        const { audio } = await fetchTTS(text);
        const el = new Audio(`data:audio/mp3;base64,${audio}`);
        audioRef.current = el;
        el.onended = () => setSpeaking(false);
        el.onerror = () => browserSpeak(text);
        await el.play();
      } catch (e) {
        browserSpeak(text);
      }
    },
    [browserSpeak]
  );

  return { speak, speaking };
}
